var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLockimage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none",
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F5F",
    fillRule: "evenodd",
    d: "M12.071 2H4.93a.5.5 0 0 0-.5.5v1.976h8.142V2.5a.5.5 0 0 0-.5-.5ZM4.93 0a2.5 2.5 0 0 0-2.5 2.5v2.358A2.5 2.5 0 0 0 0 7.358V14.5A2.5 2.5 0 0 0 2.5 17h12a2.5 2.5 0 0 0 2.5-2.5V7.357a2.5 2.5 0 0 0-2.429-2.499V2.5a2.5 2.5 0 0 0-2.5-2.5H4.93Zm5.595 9.31a2.02 2.02 0 0 1-.81 1.619v1.619a1.214 1.214 0 1 1-2.428 0v-1.62a2.024 2.024 0 1 1 3.238-1.62Z",
    clipRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockimage);
export default __webpack_public_path__ + "static/media/lockimage.98255c3ea2a8c2cff8c41b0466fe25f6.svg";
export { ForwardRef as ReactComponent };